export const fromInputDefaultAirports = [
  {
    code: "DYU",
    countryCode: "TJ",
    countryName: {
      ru: "Таджикистан",
      en: "Tajikistan",
      tj: "Тоҷикистон",
    },
    name: {
      ru: "Душанбе",
      en: "Dushanbe",
      tj: "Душанбе",
    },
    isMain: true,
  },
  {
    code: "LBD",
    countryCode: "TJ",
    countryName: {
      ru: "Таджикистан",
      en: "Tajikistan",
      tj: "Тоҷикистон",
    },
    name: {
      ru: "Худжанд",
      en: "Khudzhand",
      tj: "Хуҷанд",
    },
    isMain: true,
  },
  {
    code: "TJU",
    countryCode: "TJ",
    countryName: {
      ru: "Таджикистан",
      en: "Tajikistan",
      tj: "Тоҷикистон",
    },
    name: {
      ru: "Куляб",
      en: "Kulyab Airport",
      tj: "Кӯлоб",
    },
    isMain: true,
  },
  {
    code: "KQT",
    countryCode: "TJ",
    countryName: {
      ru: "Таджикистан",
      en: "Tajikistan",
      tj: "Тоҷикистон",
    },
    name: {
      ru: "Международный аэропорт Бохтар",
      en: "Bokhtar International Airport",
      tj: "Фурудгоҳи байналмилалии Бохтар",
    },
    isMain: true,
  },
];

export const toInputDefaultAirports = [
  {
    code: "TAS",
    countryCode: "UZ",
    countryName: {
      ru: "Узбекистан",
      en: "Uzbekistan",
      tj: "Ӯзбекистон",
    },
    name: {
      ru: "Международный аэропорт Ташкента",
      en: "Tashkent international airport",
      tj: "Фурудгоҳи байналмилалии Тошканд",
    },
    isMain: true,
  },
  {
    code: "MOW",
    countryCode: "RU",
    countryName: {
      ru: "Россия",
      en: "Russia",
      tj: "Русия",
    },
    name: {
      ru: "Москва",
      en: "Moscow",
      tj: "Маскав",
    },
    isMain: true,
  },
  {
    code: "SVO",
    countryCode: "RU",
    countryName: {
      ru: "Россия",
      en: "Russia",
      tj: "Русия",
    },
    name: {
      ru: "Шереметьево",
      en: "Sheremetyevo International",
      tj: "Фурудгоҳи байналмилалии Шереметево",
    },
    isMain: false,
  },
  {
    code: "VKO",
    countryCode: "RU",
    countryName: {
      ru: "Россия",
      en: "Russia",
      tj: "Русия",
    },
    name: {
      ru: "Внуково",
      en: "Vnukovo International",
      tj: "Фурудгоҳи байналмилалии Внуково",
    },
    isMain: false,
  },
  {
    code: "DME",
    countryCode: "RU",
    countryName: {
      ru: "Россия",
      en: "Russia",
      tj: "Русия",
    },
    name: {
      ru: "Домодедово",
      en: "Domodedovo",
      tj: "Домодедово",
    },
    isMain: false,
  },
  {
    code: "DXB",
    countryCode: "AE",
    countryName: {
      ru: "Объединенные Арабские Эмираты",
      en: "United Arab Emirates",
      tj: "Аморатҳои Муттаҳидаи Араб",
    },
    name: {
      ru: "Дубай",
      en: "Dubai",
      tj: "Дубай",
    },
    isMain: true,
  },
  {
    code: "IST",
    countryCode: "TR",
    countryName: {
      ru: "Турция",
      en: "Turkey",
      tj: "Туркия",
    },
    name: {
      ru: "Стамбул",
      en: "Istanbul",
      tj: "Истанбул",
    },
    isMain: true,
  },
  {
    code: "ALA",
    countryCode: "KZ",
    countryName: {
      ru: "Казахстан",
      en: "Kazakhstan",
      tj: "Қазоқистон",
    },
    name: {
      ru: "Алматы",
      en: "Almaty",
      tj: "Алмаато",
    },
    isMain: true,
  },
  {
    code: "BSZ",
    countryCode: "KG",
    countryName: {
      ru: "Кыргызстан",
      en: "Kyrgyz",
      tj: "Қирғизистон",
    },
    name: {
      ru: "Бишкек",
      en: "Bishkek",
      tj: "Бишкек",
    },
    isMain: true,
  },
];
